var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLogIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.73437V12.6875",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.9766V15.2656",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7775_11528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.999998H23V23H1V0.999998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7775_11528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5644 4.05394C19.2929 5.63232 21.1667 8.65854 21.1667 12.0374C21.1667 17.079 17.0417 21.166 12.0001 21.166C11.212 21.166 10.4473 21.0662 9.7179 20.8784",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43573 19.9434C4.70718 18.365 2.83337 15.4149 2.83337 12.036C2.83337 6.9944 6.95845 2.83128 12 2.83128C12.7881 2.83128 13.5528 2.93113 14.2822 3.11887",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.417 3.97543H16.5643V6.82812",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43571 17.1727V20.0254H4.58301",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5643 9.68097L14.2821 7.39881H9.71783L7.43567 9.68097V14.3214L9.71783 16.6035H14.2821L16.5643 14.3214V9.68097Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLogIcon);
export default __webpack_public_path__ + "static/media/ErrorLogIcon.ec05cc4be4809c4482c7a268d27f308b.svg";
export { ForwardRef as ReactComponent };